import React from "react";
import { Link } from "react-router-dom";
import {
  ArrowRight, Phone, CheckCircle2,
  CarFront, Paintbrush, Sparkles, Frame, Truck, KeyRound, FileCheck, ClipboardList, Car,
} from "lucide-react";
import { Button } from "../components/ui/button";
import { BUSINESS, SERVICES } from "../mock";

const iconMap = { CarFront, Paintbrush, Sparkles, Frame, Truck, KeyRound, FileCheck, ClipboardList, Car };

const Services = () => {
  return (
    <div data-testid="services-page">
      {/* Page hero */}
      <section className="bg-zinc-950 py-20 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-[500px] h-[300px] bg-red-600/10 rounded-full blur-3xl" aria-hidden="true" />
        <div className="max-w-7xl mx-auto px-6 lg:px-8 relative">
          <span className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.22em] uppercase text-red-500 mb-4">
            <span className="w-8 h-[2px] bg-red-500 inline-block" /> What We Do
          </span>
          <h1 className="font-heading text-5xl lg:text-6xl font-extrabold tracking-tight text-white mb-5">
            Our <span className="text-red-500">Services</span>
          </h1>
          <p className="text-zinc-400 text-lg max-w-2xl leading-relaxed">
            Friendly auto-repair specialists who'll take the time to explain the work and give reliable, honest estimates — every single time.
          </p>
        </div>
      </section>

      {/* Services grid */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {SERVICES.map((s) => {
              const Icon = iconMap[s.icon];
              return (
                <div key={s.id} className="group bg-white rounded-xl p-8 border border-zinc-100 shadow-sm hover:shadow-xl hover:-translate-y-1.5 transition-all duration-300" data-testid={`service-full-card-${s.id}`}>
                  <div className="w-14 h-14 rounded-xl bg-red-50 text-red-600 flex items-center justify-center mb-6 group-hover:bg-red-600 group-hover:text-white transition-colors duration-300">
                    <Icon size={26} />
                  </div>
                  <h3 className="font-heading text-xl font-bold text-zinc-900 mb-3">{s.title}</h3>
                  <p className="text-sm text-zinc-600 leading-relaxed mb-6">{s.description}</p>
                  <Link to="/appointment" className="inline-flex items-center gap-1.5 text-sm font-bold text-red-600 hover:gap-3 transition-all duration-200 uppercase tracking-wide">
                    Book This Service <ArrowRight size={15} />
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Guarantee band */}
      <section className="pb-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="bg-zinc-50 border border-zinc-100 rounded-2xl p-10 lg:p-14 grid lg:grid-cols-2 gap-10 items-center">
            <div>
              <h2 className="font-heading text-3xl lg:text-4xl font-extrabold tracking-tight text-zinc-900 mb-4">
                The <span className="text-red-600">CaliberAUTO</span> Promise
              </h2>
              <p className="text-zinc-600 leading-relaxed mb-6">
                We treat you as the customer — not your insurance company. Every repair comes with honest communication, fair pricing, and factory-quality workmanship.
              </p>
              <ul className="space-y-3">
                {["Free, on-the-spot estimates with multiple options", "We coordinate with insurance & rental companies for you", "Fast turnaround — most jobs done in days", "Veteran-owned discipline & attention to detail"].map((item) => (
                  <li key={item} className="flex items-start gap-3 text-sm font-medium text-zinc-800">
                    <CheckCircle2 size={18} className="text-red-600 mt-0.5 shrink-0" /> {item}
                  </li>
                ))}
              </ul>
            </div>
            <div className="bg-zinc-900 rounded-2xl p-10 text-center">
              <p className="text-xs font-bold tracking-[0.25em] uppercase text-red-500 mb-3">Need Help Now?</p>
              <p className="font-heading text-3xl font-extrabold text-white mb-6">Get Your Free Estimate</p>
              <div className="flex flex-col gap-3">
                <Button asChild size="lg" className="bg-red-600 hover:bg-red-700 text-white font-semibold uppercase tracking-wide text-sm h-13 h-14 rounded-md transition-all duration-200" data-testid="services-cta-book">
                  <Link to="/appointment">Make an Appointment</Link>
                </Button>
                <Button asChild size="lg" variant="outline" className="border-zinc-700 bg-transparent text-zinc-200 hover:bg-zinc-800 hover:text-white font-semibold uppercase tracking-wide text-sm h-14 rounded-md transition-all duration-200" data-testid="services-cta-call">
                  <a href={BUSINESS.phoneHref}><Phone size={16} className="mr-1.5" /> {BUSINESS.phone}</a>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
